import * as CONST from "./actionTypes";

const INIT_STATE = {
  error: "",
  loading: false,
  list: [],
  total: 0,
  AUDLoading: false
};

const Uniramp = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CONST.GET_QUOTE_LIST:
      return {
        ...state,
        AUDLoading: true,
      };

    case CONST.GET_QUOTE_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload.data || [],
        AUDLoading: false,
        error: "",
      };

    case CONST.GET_QUOTE_LIST_FAIL:
      return {
        ...state,
        list: [],
        AUDLoading: false,
        error: "",
      };
      case CONST.CREATE_TRANSACTION:
        return {
          ...state,
          loading: true,
        };
  
      case CONST.CREATE_TRANSACTION_SUCCESS:
        return {
          ...state,
          loading: false,
          error: "",
        };
  
      case CONST.CREATE_TRANSACTION_FAIL:
        return {
          ...state,
          loading: false,
          error: "",
        };
    
    
    default:
      return state;
  }
};

export default Uniramp;
